var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-icon',{attrs:{"icon":_vm.iconName,"type":_vm.type,"title":`${_vm.flag ? 'Ja' : 'Nein'}`}})
}
var staticRenderFns = []

export { render, staticRenderFns }